/*
登陆的路由组件
 */
import React, { Component } from 'react';
import { Carousel } from 'element-react';
import { requests, getToken, loadZhuKeToken, getLoginShopInfo, systemConfig, funSplitType, requestExternal } from '../../utils/http';
import { getStorage, setStorage } from '../../utils/common'
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      moreUrl: "https://ufuwu.1688.com/page/fuwu_work_isv_container.htm?appkey=8076003",
      expiredDay: "绑定后显示",//过期天数
      shopName: "",
      payUrl: "",
      isShowNewUserGuide: props.isShowNewUserGuide,
      funSplitTypes: funSplitType(),
      carouselImgs: [],  //顶部广告轮播图
      addADId: "",
      articleADcontent: "",
      isHasToBanner: false,
      isShowCloseTopIcon: false
    };

  }

  componentDidMount() {


    //当前登录的信息
    var shopInfo = getLoginShopInfo();
    if (shopInfo.loginShopName != null && shopInfo.loginShopName != "" && shopInfo.loginShopName != undefined)
      this.loadLoginShopData();
    else {
      setTimeout(() => {
        var shopInfoTwo = getLoginShopInfo();
        if (shopInfoTwo.loginShopName != null && shopInfoTwo.loginShopName != "" && shopInfoTwo.loginShopName != undefined)
          this.loadLoginShopData();
        else {
          setTimeout(() => {
            this.loadLoginShopData();
          }, 600);
        }
      }, 500);
    }


    this.loadfunSplitTypes();

    //有绑定主客信息时，获取当前店铺的过期时间
    var zhukeToken = getToken();
    var that = this;
    if (zhukeToken != "")
      that.loadLoginShopExpiredDay();
    else {
      setTimeout(() => {
        var zhukeTokenTwo = getToken();
        if (zhukeTokenTwo == "") {
          var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
          if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
            //loadZhuKeToken(hasZhukeLoginShopTokens);

            setTimeout(() => {
              that.loadLoginShopExpiredDay();
            }, 500);
          }
        } else
          that.loadLoginShopExpiredDay();
      }, 500);
    }
    this.IsSowTopAndDailogAD();
  }


  IsSowTopAndDailogAD = () => {
    let num=0;
    let sowTopAndDailogADTimer=setInterval(() => {
      num++;
      if (systemConfig.platformType) {
        this.showTopAndDailogAD();
        clearInterval(sowTopAndDailogADTimer);
      }
      if(num>=20){
        clearInterval(sowTopAndDailogADTimer);
      }
    }, 100)
  }


  loadfunSplitTypes = () => {
    let startNum = 0;
    let headerMenuTimer = null;
    headerMenuTimer = setInterval(() => {
      this.setState({
        funSplitTypes: funSplitType(),
      })
      startNum = startNum - 0 + 1;
      if (startNum >= 20) { //超过10秒 清除延时器
        clearInterval(headerMenuTimer);//清除延时器
      }
    }, 100);
  }



  loadLoginShopData = () => {
    var shopInfo = getLoginShopInfo();
    var expiredDay = this.state.expiredDay;
    var shopName = this.state.shopName;
    var payUrl = this.state.payUrl;

    if (shopInfo.loginShopName != null && shopInfo.loginShopName != "")
      shopName = shopInfo.loginShopName;
    if (shopInfo.loginShopExpiredDay != null && shopInfo.loginShopExpiredDay != "")
      expiredDay = shopInfo.loginShopExpiredDay;
    if (shopInfo.loginShopPayUrl != null && shopInfo.loginShopPayUrl != "")
      payUrl = shopInfo.loginShopPayUrl;



    this.setState({
      shopName: shopName,
      //expiredDay:expiredDay,
      //payUrl:payUrl,
    })
    if (payUrl != "" && payUrl != null && payUrl != undefined)
      this.setState({ payUrl: payUrl });//不一定有绑定阿里，所以这里先赋值

  }

  loadLoginShopExpiredDay = () => {
    var shopInfo = getLoginShopInfo();
    var shopid = shopInfo.loginShopId;
    var platformType = shopInfo.loginShopPlatformType;

    var zhukeToken = getToken();
    if (zhukeToken != "") {
      var that = this;
      requests({
        url: "/MyShop/List",
        data: { PlatformType: platformType },
        success: function (res) {
          if (res.Success) {
            var listData = res.Data.DataList.Shops;
            for (let i = 0; i < listData.length; i++) {
              if (shopid == listData[i].Id) {
                that.setState({ expiredDay: listData[i].ServiceEndTime });
                break;
              }
            }
            localStorage.setItem('home_shop_list', JSON.stringify(listData))
            var urlList = res.Data.UrlList;
            for (let i = 0; i < urlList.length; i++) {
              if (platformType == urlList[i].PlatformType) {
                setTimeout(() => {
                  //如果是快手应用且是订单应用则走这个逻辑
                  if (platformType == "KuaiShou" && that.state.funSplitTypes == 2) {
                    that.setState({ payUrl: decodeURIComponent(urlList[i].PayUrlByOrderNew) });
                  } else {

                    that.setState({ payUrl: decodeURIComponent(urlList[i].PayUrl) });
                  }
                }, 1000);//避免覆盖，延迟赋值
                break;
              }
            }


          }
        },
        fail: (err) => { }
      });


    }
  }


  buyButton = () => {
    window.open(this.state.payUrl, "_blank")
  }

  showTopAndDailogAD = async () => {
    let res = await this.getTopAndDailogAD();
    if (res.success) {
      let topBannerData = res.resultData.topBannerData;
      let isHasToBanner = JSON.stringify(topBannerData) != '{}' ? true : false;
      if (isHasToBanner) {
        let delAddArray = getStorage("delADIds") || [];
        let articleId = topBannerData.articleId;
        let isDel = false;
        delAddArray.forEach((item) => {
          if (item == articleId) {
            isDel = true;
          }
        })
        this.setState({ isHasToBanner: !isDel, isShowCloseTopIcon: topBannerData.isShowCloseTopIcon })
        if (!isDel) {  //判断是否被删除了，被删除不展示
          if (Array.isArray(topBannerData.adPics)) {
            this.setState({ carouselImgs: topBannerData.adPics, addADId: articleId })
          }
          if (topBannerData.articlecontent) {
            this.setState({ articleADcontent: topBannerData.articlecontent, addADId: articleId })
          }
        }
      }
    }
  }

  getTopAndDailogAD = () => {
    const data = {};
    data.type = "showAD";
    data.topType = "zkComTopBanner";
    data.midType = "zkComMidBanner";
    data.platformType = systemConfig.platformType;
    data.shopId = systemConfig.curShopId;
    return new Promise((resolve, reject) => {
      requestExternal({
        url: systemConfig.requestExternalUrl + "/pcZk/topAndDailogAD",
        data: data,
        success: function (res) {
          resolve(res)
        },
        fail: (err) => { }
      });
    })
  }

  addADClick = (picId) => {
    const data = {};
    data.articleId = this.state.addADId;
    data.type = "addADClick";
    data.picId = picId ? picId : "";
    requestExternal({
      url: systemConfig.requestExternalUrl + "/pcZk/topAndDailogAD",
      data: data,
      success: function (res) { },
      fail: (err) => { }
    });
  }

  closeArticleADcontent = () => {
    let delAddArray = getStorage("delADIds") || [];
    delAddArray.push(this.state.addADId);
    setStorage("delADIds", delAddArray);
    this.setState({ isHasToBanner: false });
  }

  render() {
    return (
      <div className={this.state.isHasToBanner ? "hasToBanner" : ""}>
        <header className={this.state.funSplitTypes == 1 ? 'phzs-header' : this.state.funSplitTypes == 2 ? 'cgxd-header' : ''}>
          {
            this.state.isHasToBanner ?
              <div className='header-ad-wrap'>
                {
                  this.state.carouselImgs.length > 0 ?
                    <Carousel height="48px" autoplay={false}>
                      {
                        this.state.carouselImgs.map((item, index) => {
                          return (
                            <Carousel.Item key={index}>
                              <div><a href={item.Url} target='_blank' onClick={() => this.addADClick(item.Id)}><img className='carousel-img' src={systemConfig.requestExternalUrl + item.FileContent} alt="" /></a></div>
                            </Carousel.Item>
                          )
                        })
                      }
                    </Carousel> : <div className='articleADcontentWrap' dangerouslySetInnerHTML={{ __html: this.state.articleADcontent }} />
                }
                {
                  this.state.isShowCloseTopIcon == "1" ?
                    <i className='iconfont icon-chuyidong' onClick={() => this.closeArticleADcontent()}></i> : null
                }

              </div> : null
          }

          <div style={{ display: "flex", justifyContent: 'space-between', height: '48px' }}>
            <div className='header-left'>
              {/* 视频号新应用,发布视频号时这个要注释掉 */}
              {
                this.state.funSplitTypes == 1 ?
                  <img src="https://www.dgjapp.com/public/images/kaifang/allpuhuo-logo-phzs.png" /> :
                  this.state.funSplitTypes == 2 ?
                    <img src="https://www.dgjapp.com/public/images/kaifang/allpuhuo-logo-phcg.png" /> :
                    <img src="https://www.dgjapp.com/public/images/kaifang/allpuhuo-logo.png" />
              }

            </div>
            <div className="header-right">
              <div className='header-right-contact'>
                <div className="contact-item">
                  <i className='iconfont icon-guanfangbanben'></i>
                  <a style={{ color: "#fff" }} href={this.state.moreUrl} target="_blank"> 多店版</a>
                </div>
                <div className="contact-item">
                  <i className='iconfont icon-kefu2'  ></i>

                  {
                    systemConfig.QQContactWay ?
                      <a href={systemConfig.QQContactWay.QQ} style={{ color: "#fff" }} target="_blank">
                        联系客服
                      </a> :
                      <a href='https://wpa1.qq.com/biYkihFL?_type=wpa&qidian=true' style={{ color: "#fff" }} target="_blank">
                        联系客服
                      </a>
                  }
                  {/* className='animateText' */}
                  {/* <div className='contact-maiwrap'>
                <img src="https://www.dgjapp.com/public/images/kaifang/h5-puhuo_6.png" />
                <span>扫一扫,联系客服</span>
              </div> */}
                </div>

              </div>
              <div className='header-right-userInfo'>
                <div className="userInfo-name">{this.state.shopName}</div>
                <div className="userInfo-date">
                  <span>过期时间：{this.state.expiredDay}</span>

                  <span className='userInfo-btn' onClick={() => this.buyButton()}>续订</span>
                </div>
              </div>
            </div>

          </div>

        </header>
      </div>

    )
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/headerMenu/headerMenu.jsx